import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { ContratosResponseViewModel, ContratosPedidosViewModel } from '../../../venda/cadastros/contratos/model/ConsultaContratosViewModel';
import { ModalBasicComponent } from '../../../shared/modal-basic/modal-basic.component';
import { DimDatatableColumn } from '@models';
import { StatusPedido } from '../../../model/statusPedido';
import { ParamConsulta } from '@generals';
import { DimDatatableComponent } from '../../../shared/dim-datatable/dim-datatable.component';

@Component({
  selector: 'app-modal-visualizar-pedidos-contrato',
  templateUrl: './modal-visualizar-pedidos-contrato.component.html',
  styleUrls: ['./modal-visualizar-pedidos-contrato.component.css']
})
export class ModalVisualizarPedidosContratoComponent extends ModalCadastroComponent implements OnInit {
  @ViewChild('modal', { static: true }) modal: ModalBasicComponent;
  @ViewChild('table', { static: true }) table: DimDatatableComponent;
  contrato: ContratosResponseViewModel = null;
  columns: DimDatatableColumn[] = [
    { col: 'numeroPedido', label: 'Número', hide: false },
    { col: 'emissao', label: 'Data do pedido', date: true, hide: false },
    { col: 'dataBaseVencimentos', label: 'Data de vencimento', format: (x: string) => x ? new Date(x).toLocaleDateString('pt-BR') : 'Sem Vencimento', hide: false },
    { col: 'dataCompetenciaContrato', label: 'Data da competência', getDescription: (x: ContratosPedidosViewModel) => new Date(x.dataCompetenciaContrato).toLocaleDateString('pt-BR') ?? this.formataMes(this.contrato.ultimoMesGerado || 1), hide: false },
    { col: 'valorTotal', label: 'Valor total', currency: true, hide: false },
    { col: 'status', label: 'Status', format: (x: string) => StatusPedido.listar().find(s => s.id === x)?.descricao || '', hide: false },
  ]
  meses = {
    '1': 'Janeiro',
    '2': 'Fevereiro',
    '3': 'Março',
    '4': 'Abril',
    '5': 'Maio',
    '6': 'Junho',
    '7': 'Julho',
    '8': 'Agosto',
    '9': 'Setembro',
    '10': 'Outubro',
    '11': 'Novembro',
    '12': 'Dezembro'
  };

  ngOnInit(): void {
    this.contrato = this.prop;
  }

  get numeroContrato() {
    return this.contrato?.numero || '';
  }

  get clienteNome() {
    return this.contrato?.clienteNome || '';
  }

  formataMes(numeroMes: number) {
    return this.meses[numeroMes] || 'Mês inválido';
  }

  show() {
    this.modal.show();
  }

  fechar(value: any = false) {
    this.closed.emit(value);
  }

  redirectToPedido(row) {
    window.open(`/venda/pedidos/editar/${row.id}`, '_blank');
  }
}
